import React from "react";
import { styled } from "@linaria/react";
import { Source } from "@components/_Revamp/Listing";
import { Text } from "@pages/ShieldStarter/Components/Text";
import { themeDefault } from "src/theme-revamp";
import checkCircleIcon from "@assets/icon/check-circle.svg";
import { css } from "@linaria/core";
import { Helpers } from "@utils/helpers";

interface CardListProps {
  sources: Source[];
  validQRClient?: boolean;
}

const CardContianer = styled.div`
  display: grid;
  grid-column: 2 / span 12;
  grid-template-columns: repeat(12, minmax(auto, 1fr));
  grid-gap: 16px;

  @media only screen and (max-width: 768px) {
    grid-column: 2 / span 6;
    grid-template-columns: repeat(6, 1fr);
  }
`;

const Card = styled.div`
  display: flex;
  grid-column-end: span 4;
  display: flex;
  flex-direction: column;
  background-color: #faf4f9;
  border-radius: 24px;
  padding: 24px;
  transition: all 0.3s ease 0s;

  @media only screen and (max-width: 768px) {
    grid-column-end: span 12;
  }

  @media only screen and (max-width: 1024px) {
    grid-column-end: span 6;
  }
`;

const TextContainer = styled.div`
  display: flex;
  margin: 5px 0;
`;

const IconElement = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

const existingCss = css`
  font-weight: 400;
`;
const addOnCss  = css`
  font-weight: 600; 
`;

const existingAndAddonCss  = css`
  font-size: 14px;
  color: #883E89;
  margin-bottom: 0.5rem;
  margin-top: 0.25rem;
`;

const CardList = ({ sources, validQRClient }: CardListProps) => {
  const parseCurrency = (value?: string): number => {
    return Number(value?.replace(/[^0-9.-]+/g, ""));
  };
  return (
    <>
      <CardContianer>
        {sources.map((item, index) => (
          <Card key={index}>
            <Text
              variant="base"
              fontWeight={600}
              color={themeDefault.colors.primary}
              fontSize="18px"
            >
              {(validQRClient && item.heading.text === "Rehabilitation Benefit" && item.heading.basicPlanSelected) ? Helpers.toCurrencyND(parseCurrency(item.heading.eyaMonthlyBenefit) + (parseCurrency(item.heading.value) - parseCurrency(item.heading.existingMonthlyBenefit))) :   (item.heading.text === "Rehabilitation Benefit" && !item.heading.basicPlanSelected ? "-" : item.heading.value)}
            </Text>
            { 
              validQRClient && item.heading.text !== "Rehabilitation Benefit"  && <div className={existingAndAddonCss}>
                <span className={existingCss}>{item.heading.existingMonthlyBenefit} (existing)</span>
                <span className={addOnCss}> + {Helpers.toCurrencyND(parseCurrency(item.heading.value) - parseCurrency(item.heading.existingMonthlyBenefit))} (add-on)</span></div>
            } 
            { 
              validQRClient && item.heading.text === "Rehabilitation Benefit" && item.heading.basicPlanSelected  && <div className={existingAndAddonCss}>
                <span className={existingCss}>{item.heading.eyaMonthlyBenefit} (existing)</span>
                <span className={addOnCss}> + {Helpers.toCurrencyND(parseCurrency(item.heading.value) - parseCurrency(item.heading.existingMonthlyBenefit))} (add-on)</span></div>
            }     
            <TextContainer>
              <IconElement src={checkCircleIcon} alt="check-circle-icon" />
              <Text
                variant="base"
                fontWeight={600}
                fontSize="14px"
                margin="3px 5px"
              >
                {item.heading.text}
              </Text>
            </TextContainer>

            {item?.descriptions &&
              item?.descriptions.map((description) => (
                <Text variant="base" fontSize="14px" fontWeight={400}>
                  {description.text}
                </Text>
              ))}
            {item?.subDescriptions &&
              item?.subDescriptions.map((description) => (
                <Text variant="base" fontSize="12px" fontWeight={500}>
                  {description.text}
                </Text>
              ))}
          </Card>
        ))}
      </CardContianer>
      <Card style={{ marginTop: "20px" }}>
        <Text
          variant="base"
          fontWeight={600}
          color={themeDefault.colors.primary}
          fontSize="18px"
        >
          {"Included"}
        </Text>
        <TextContainer>
          <IconElement src={checkCircleIcon} alt="check-circle-icon" />
          <Text
            variant="base"
            fontWeight={600}
            fontSize={"14px"}
            margin="3px 5px"
          >
            {"Waiver of Premium (unable to perform at least 1 ADL)"}
          </Text>
        </TextContainer>
        <TextContainer>
          <IconElement src={checkCircleIcon} alt="check-circle-icon" />
          <Text
            variant="base"
            fontWeight={600}
            fontSize={"14px"}
            margin="3px 5px"
          >
            {"Increase payout at selected life stage events without further underwriting"}
          </Text>
        </TextContainer>
      </Card>
    </>
  );
};

export default CardList;
